export const TABLET_VITALS_METER = 'tablet-vitals'
export const TABLET_VITALS_METER_CLASSIFIED_ENTRIES_FROM_TABLET =
  TABLET_VITALS_METER + '.classified-entries-from-tablet'
export const METER_PROVIDER_SERVICE_NAME = 'client-app-metric'
export const METER_PROVIDER_SERVICE_VERSION = '0.0.1'
